/* Tiny route-transition fallback. Renders below the navbar so the
   header (already mounted globally) stays visible while the lazy page
   chunk loads. Just a faint pulsing brand line so the user knows
   something's happening — most lazy chunks load in <100ms anyway. */
export default function PageLoader() {
  return (
    <div
      data-testid="page-loader"
      className="fixed left-0 right-0 z-30"
      style={{ top: 64, height: 2 }}
      aria-label="Loading page"
    >
      <div
        className="h-full"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, var(--brand) 50%, transparent 100%)",
          backgroundSize: "200% 100%",
          animation: "pageloader-sweep 1s linear infinite",
        }}
      />
      <style>{`
        @keyframes pageloader-sweep {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
}
